import { useEffect, useState } from 'react';

const navLinks = [
  { label: '今日热瓜', href: '#trending' },
  { label: '表情包仓库', href: '#gallery' },
  { label: '段子神评', href: '#jokes' },
  { label: '高频问答', href: '#faq' },
  { label: '关于每日看瓜', href: '#about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-xl">🍉</span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-lg text-primary-600">每日看瓜</span>
            <span className="hidden text-[11px] text-foreground-500 sm:block">梗图·段子·神评论仓库</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2.5">
          <a
            href="#contact"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            投稿 / 求图
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-secondary-800 lg:hidden"
          >
            <i className={`ri-${open ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="mx-4 mb-3 rounded-2xl border border-background-200 bg-background-50 p-2 lg:hidden">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block rounded-xl px-4 py-3 text-sm font-medium text-foreground-800 hover:bg-primary-100 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-1 block rounded-xl bg-primary-500 px-4 py-3 text-center text-sm font-bold text-background-50"
          >
            投稿 / 求图
          </a>
        </div>
      )}
    </header>
  );
}